import PropTypes from 'prop-types';
export var VALUE_TYPE = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
export var OPTION_TYPE = PropTypes.shape({
  key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string.isRequired,
  value: VALUE_TYPE.isRequired,
  disabled: PropTypes.bool,
  data: PropTypes.object,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.shape({
    option: PropTypes.object,
    value: PropTypes.object
  })]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    option: PropTypes.string,
    value: PropTypes.string
  })])
});
export var OPTION_GROUP_TYPE = PropTypes.shape({
  label: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(OPTION_TYPE)]).isRequired
});
export var OPTIONS_TYPE = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(OPTION_GROUP_TYPE), PropTypes.arrayOf(OPTION_TYPE)]);